/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import {
  ProgressBar,
  BodyContainer,
  LeftContainer,
  RightContainer,
  BodyTitle,
  SubmitButton,
  Preview,
  Conclusion,
  UserGroupListComp,
  NextButton,
} from '../components';
import { useTheme } from '@providers/theme';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { useSMsupplyStepper, useSMcreateTransaction } from '../machines';
import { VApplication } from '@/application';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { SupplyStepperPageService } from '../services';
import { useLocation, useNavigate } from 'react-router-dom';

//
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.SupplyStepperPageService'
  ) as SupplyStepperPageService;
};

export const ContainerComm = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const [userGroupList, setUserGroupList] = useState(null);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const staticPageContentConfig: any = getSrv().getStaticPageContent();
  const srv = getSrv();
  const { supplyStepperPageSend, supplyStepperPageState } = useSMsupplyStepper(
    {}
  );

  const {
    createTransactionMachine,
    createTransactionSend,
    createTransactionState,
  } = useSMcreateTransaction({});

  const onActiveStepChange = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const onPaginationChange = (event: any) => {
    supplyStepperPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const onStepperClose = () => {
    // srv?.resetFormData();
    // props?.onCloseClick && props?.onCloseClick();
  };

  const onFormSubmit = (data: any) => {
    window.scrollTo(0, 0);
    srv?.setSupplyCropForm(data);
    setActiveStep(activeStep + 1);
  };

  const onComplianceSubmit = (data: any) => {
    window.open(
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.infy-demos/excise_demo/excise_unique_qrs.csv',
      '_blank'
    );
    // window.scrollTo(0, 0);
    // srv?.setComplianceForm(data);
    // setActiveStep(activeStep + 1);
    navigate('/batches/supply-chain-template');
  };

  const onOrgSelectSubmit = () => {
    srv?.setOrgSelected(userGroupList);
    setActiveStep(activeStep + 1);
    window.scrollTo(0, 0);
  };

  const onUserGroupCardClick = (items: any) => {
    // console.log('user group selected', items);
    setUserGroupList(items);
  };

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const getAcknowledgement = () => {
    return (
      <div>
        <Conclusion />
      </div>
    );
  };

  const _renderNextButton = () => {
    return <NextButton onNextButtonPress={onOrgSelectSubmit} v />;
  };

  const onPreviewSubmit = () => {
    window.scrollTo(0, 0);
    // createTransactionSend('START', {
    //   payload: {
    //     complianceData: state?.detail?.entitledComplianceDocsTemplate,
    //   },
    // });
    setActiveStep(activeStep + 1);
  };

  const _getPreviewData = () => {
    return (
      <Preview
        {...(srv?.getPreview() || {})}
        title={state?.detail?.traceOutput}
        heroImage={{
          image: state?.detail?.icon,
          title: state?.detail?.traceOutput,
        }}
        // onPreviewSubmit={onPreviewSubmit}
      />
    );
  };

  const _renderPagination = () => {
    return (
      <Paginate
        {...(supplyStepperPageState?.event?.data?.value?.userGroups || {})}
        onPageChange={onPaginationChange}
        key={refreshPagination}
        totalItems={
          supplyStepperPageState?.event?.data?.value?.userGroups?.totalCount
        }
      />
    );
  };

  const _renderPreviewSubmit = () => {
    return <NextButton onNextButtonPress={onPreviewSubmit} title={'Submit'} />;
  };

  const _renderBody = () => {
    console.log(`state detail::`, state?.detail);
    const formFields = staticPageContentConfig?.stepFields?.step1;
    const complianceData = state?.detail?.entitledComplianceDocsTemplate;
    const org = state?.detail?.entitledRecipients;
    const getFormattedOrgList = srv?.formatOrgList(org);
    const getFormatComplForm = srv?.formatComplForm(complianceData);
    if (
      // supplyStepperPageState?.matches('RENDER_PAGE') &&
      // supplyStepperPageState?.event?.data?.value
      formFields
    ) {
      console.log('supplyStepperPageState', supplyStepperPageState);
      switch (activeStep) {
        case 0:
          return (
            <>
              <LeftContainer>
                {/* <BodyTitle
                  {...(supplyStepperPageState?.event?.data?.value?.cropForm ||
                    {})}
                /> */}
                <TweetyWidget
                  key={activeStep + 1}
                  labelColor={theme.colors.primary}
                  fields={staticPageContentConfig?.stepFields?.step1}
                  // layout={
                  //   supplyStepperPageState?.event?.data?.value?.cropForm?.layout
                  // }
                  initialData={srv?.getCropFormData()}
                  onFormSubmit={onFormSubmit}
                  renderSubmitButton={renderSubmitButton}
                />
              </LeftContainer>
              {/* <RightContainer
                rightBlockContent={
                  supplyStepperPageState?.event?.data?.value?.cropForm
                    ?.rightBlockContent
                }
              /> */}
            </>
          );
        case 1:
          return (
            <>
              <LeftContainer>
                <BodyTitle
                  {...(supplyStepperPageState?.event?.data?.value
                    ?.complianceStep || {})}
                />
                <TweetyWidget
                  key={activeStep + 1}
                  labelColor={theme.colors.primary}
                  fields={staticPageContentConfig?.stepFields?.step2}
                  //initialData={srv?.getComplianceData()}
                  onFormSubmit={onComplianceSubmit}
                  //renderSubmitButton={renderSubmitButton}
                />
              </LeftContainer>
              <RightContainer
                rightBlockContent={
                  supplyStepperPageState?.event?.data?.value?.complianceStep
                    ?.rightBlockContent
                }
              />
            </>
          );
      }
    }
  };

  return (
    <>
      <ProgressBar
        onActiveStepChange={onActiveStepChange}
        activeStep={activeStep}
        totalSteps={1}
        onCloseClick={onStepperClose}
      />
      <BodyContainer>{_renderBody()}</BodyContainer>
    </>
  );
};
